import { Callout } from "components/Form/components/Callout/Callout";
import "./EgressMailWarning.scss";
import { useEffect, useState } from "react";
import { checkEgressMailRecipients, deniedEmailMessage, looksLikeEmail } from "./egressMailCheck";

export interface EgressEmailWarningProps {
    email: unknown;
    /** What the user loses when mail to the address is blocked. */
    consequence: string;
}

const DEBOUNCE_MS = 400;

/**
 * Shows an error callout while `email` is an address the workspace-mail egress
 * policies block. Renders nothing for an allowed address, an incomplete
 * address, or when the check itself fails (the backend still gates the send).
 */
export const EgressEmailWarning = ({ email, consequence }: EgressEmailWarningProps) => {
    const [message, setMessage] = useState<string | null>(null);

    useEffect(() => {
        if (!looksLikeEmail(email)) {
            setMessage(null);
            return undefined;
        }
        let isCurrent = true;
        const timer = setTimeout(() => {
            checkEgressMailRecipients([email.trim()])
                .then((result) => {
                    if (isCurrent) {
                        setMessage(deniedEmailMessage(result?.emails?.[0], consequence));
                    }
                })
                .catch(() => {
                    if (isCurrent) {
                        setMessage(null);
                    }
                });
        }, DEBOUNCE_MS);
        return () => {
            isCurrent = false;
            clearTimeout(timer);
        };
    }, [email, consequence]);

    if (!message) {
        return null;
    }
    return <Callout type="error" text={message} className="egressMailWarning" />;
};
